import { createSelector } from 'reselect';

const selectParsingRules = (state: any) => state.parsingRules;


export const selectParsingRulesCurrentItem = createSelector([selectParsingRules], (parsingRules) => parsingRules.current);

export const selectParsingRulesListItems = createSelector([selectParsingRules], (parsingRules) => parsingRules.list);

export const selectParsingRulesItemById = (itemId: any) =>
    createSelector(selectParsingRulesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectParsingRulesCreatedItem = createSelector([selectParsingRules], (parsingRules) => parsingRules.create);

export const selectParsingRulesQueryItems = createSelector([selectParsingRules], (parsingRules) => parsingRules.query);

export const selectParsingRulesUpdatedItem = createSelector([selectParsingRules], (parsingRules) => parsingRules.update);

export const selectParsingRulesReadItem = createSelector([selectParsingRules], (parsingRules) => parsingRules.read);

export const selectParsingRulesDeletedItem = createSelector([selectParsingRules], (parsingRules) => parsingRules.delete);

export const selectParsingRulesSearchedItems = createSelector([selectParsingRules], (parsingRules) => parsingRules.search);

export const selectParsingRulesItemsCount = createSelector([selectParsingRules], (parsingRules) => parsingRules.count);

export const selectParsingRulesItemsFilter = createSelector([selectParsingRules], (parsingRules) => parsingRules.filter);